<template>
  <div
    id="about"
    class="home-about d-flex flex-column flex-lg-row justify-content-between"
  >
    <div class="about-descript">
      <h2>
        <div class="sup-label">
          平台介紹
        </div>
        <div
          id="about-title"
          class="about-title"
        >
          <span
            class="main-label"
          >
            ABOUT US
          </span>
          <span
            class="main-label"
            data-depth=".2"
          >
            ABOUT US
          </span>
        </div>
      </h2>
      <div class="main-desc">
        歡迎來到
        <a href="/">
          <span>
            私服123
          </span>
        </a>
        ！
        <br>
        我們是信任度最高、經驗豐富的
        <span>
          私服遊戲推廣平台
        </span>
        <br>
        專注於提供各種遊戲私服的推廣服務。
      </div>
      <p class="about-desc">
        以超過十五年的經營經驗為後盾，致力於為遊戲私服提供最穩定、最優質的推廣平台。
      </p>
      <p class="about-desc">
        引以為傲的介面操作是業界首創最簡單方便的，讓您輕鬆設定您的私服遊戲推廣活動。
      </p>
    </div>
    <div class=" d-flex align-items-end justify-content-center">
      <div class="about-img">
        <picture>
          <source
            type="image/webp"
            :srcset="require('@/assets/images/items/platform.webp')"
          >
          <img
            :src="require('@/assets/images/items/platform.jpg')"
            alt="私服推廣平台"
          >
        </picture>
      </div>
    </div>
  </div>
</template>

<script>
import Parallax from 'parallax-js'

export default {
  components: {
  },
  directives: {
    // Ripple,
  },
  data() {
    return {
    }
  },

  computed: {
  },

  mounted() {
    const { windowWidth } = this.$store.state.app
    if (windowWidth > 576) {
      const scene = document.getElementById('about-title')
      // eslint-disable-next-line no-unused-vars
      const parallaxInstance = new Parallax(scene, {
        relativeInput: true,
      })
    }
  },

  methods: {
  },

  setup() {
  },
}
</script>
<style lang="scss" scoped>
.home-about{
  position: relative;
  height: 100%;
  min-height: 750px;
  padding: 10vh 5vw 6vh;
  background-color: black;
}
.about-descript {
  width: 80%;
  .sup-label{
    display: block;
    font-size: clamp(1rem, 2vw, 2.5rem);
    font-weight: 600;
    color: #fff;
    margin-bottom: 2rem;
  }
  .about-title {
    position: relative;
  }
  .main-label {
    position: relative;
    display: block;
    line-height: 1;
    font-size: clamp(3rem, 9vw, 12rem);
    -webkit-text-stroke-width: 0.8px;
    -webkit-text-stroke-color: #fff;
    color: rgba(255, 255, 255, 0);
    text-transform: uppercase;
  }
  .main-label:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    line-height: 1;
    -webkit-text-stroke-width: 0px;
    text-shadow: #3f48cc 10px 0px 14px;
    text-transform: uppercase;
  }
  .main-desc {
    max-width: 950px;
    margin-top: 45px;
    font-size: clamp(1.6rem, 2vw, 3rem);
    font-weight: 600;
    color: #fff;
    span {
      color: rgb(255, 69, 100);
    }
  }
  .about-desc {
    margin-top: 45px;
    font-size: 17px;
    color: #fff;
    letter-spacing: 3px;
  }
}
.about-img {
  height: 500px;
  border-radius: 20px;
  overflow: hidden;
  img {
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
}
</style>
<style lang="scss" scoped>

@media screen and (max-width: 1200px) {
  .about-img {
    height: 400px;
    img {
      height: 400px;
    }
  }
}
@media screen and (max-width: 992px) {
  .home-about{
    min-height: 1200px;
  }
  .about-descript {
    width: 100%;
  }
  .about-img {
    height: 500px;
    img {
      height: 500px;
    }
  }
}

</style>
